import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getEducationalLevelsData } from '../../utils';
import ProfileSection from '../ProfileSection';
import Schedules from '../Schedules/Schedules';

export default function EducationalLevels({ isFetching }) {
  const { schoolData } = useSchool();
  const [educationalLevels, setEducationalLevels] = useState({});
  const { activities } = getEducationalLevelsData(schoolData || {});

  useEffect(() => {
    if (activities.length) {
      assignValueById(activities, 22).then(setEducationalLevels);
    }
  }, [activities]);

  if (isFetching) {
    return <>...loading</>;
  }

  return (
    <ProfileSection
      title="Propuesta educativa"
      subtitleLyrics={{
        subtitle: 'Descripción del modelo educativo',
        lyrics: educationalLevels[0]?.description,
      }}
    >
      <Schedules subtitle="Niveles Educativos / Horarios" />
    </ProfileSection>
  );
}

EducationalLevels.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
